// write card components here
import { TfiLocationPin } from "react-icons/tfi";
import { Button } from "../button";
import { FaArrowRightLong } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import ReactGA from "react-ga4";
import moment from "moment";
import classNames from "classnames";
import _ from "lodash";

export const VenuesByStateCard = (props) => {
    return (
        <>
            <div className="border rounded-3 h-100 d-flex flex-column align-items-start card-box-shadow">
                <Link
                    className="text-center w-100"
                    to={`/complex/${props?.item?.slug}`}
                    onClick={() => {
                        ReactGA.event("complex_click", {
                            category: "complex_click",
                            action: JSON.stringify({
                                id: props?.item?.id,
                                name: props?.item?.name,
                            }),
                        });
                    }}
                >
                    <img
                        className="rounded-top-3 w-100 h-200px object-fit-cover"
                        src={props?.item?.images[0]}
                        alt="complexImg"
                    />
                </Link>

                <div className="p-3 w-100 d-flex flex-column align-items-start flex-grow-1">
                    <div className="d-grid">
                        <h5 className="fw-bold line-clamp-2">{props?.item?.name}</h5>
                    </div>
                    <Row>
                        <Col xs={1}>
                            <TfiLocationPin size={20} className="" />
                        </Col>
                        <Col xs={10}>
                            <p
                                className={classNames("mb-0 fs-14", {
                                    "line-clamp-2": props?.nearBy,
                                })}
                            >
                                {props?.item?.info?.address}
                            </p>
                            <p className="mt-2 fs-14">
                                <span className="fw-bold">Operational hours : </span>
                                {props?.item?.opening} -{" "}
                                {moment(props?.item?.opening, "HH:mm")
                                    .add(props?.item?.no_of_hours, "h")
                                    .format("HH:mm")}
                            </p>
                        </Col>
                    </Row>

                    <hr className="w-100 mt-auto" />

                    <div className="d-flex align-items-center flex-wrap">
                        {props?.item?.facilities?.length > 0 &&
                            _.uniqBy(
                                _.flatten(
                                    props?.item?.facilities?.map((item) => item?.categories)
                                )?.filter((item) => !item?.category?.parent_id),
                                "category.id"
                            )?.length > 0 &&
                            _.uniqBy(
                                _.flatten(
                                    props?.item?.facilities?.map((item) => item?.categories)
                                )?.filter((item) => !item?.category?.parent_id),
                                "category.id"
                            )
                                ?.slice(0, 2)
                                ?.map((item, index) => (
                                    <div
                                        className="d-flex align-items-center border-end me-2 mb-2"
                                        key={index}
                                    >
                                        <img
                                            className="me-1"
                                            src={item?.category?.images[0]}
                                            alt="sportIcon11"
                                            width={16}
                                        />
                                        <p className="fs-14 mb-0 me-2">{item?.category?.name}</p>
                                    </div>
                                ))}

                        {props?.item?.facilities?.length > 0 &&
                            _.uniqBy(
                                _.flatten(
                                    props?.item?.facilities?.map((item) => item?.categories)
                                )?.filter((item) => !item?.category?.parent_id),
                                "category.id"
                            )?.length > 2 && <span className="fs-14">...</span>}
                    </div>

                    <div className="d-flex justify-content-between mt-3 w-100">
                        <Link
                            className={classNames("text-center", { "w-100": props?.nearBy })}
                            to={`/complex/${props?.item?.slug}`}
                            onClick={() => {
                                ReactGA.event("complex_click", {
                                    category: "complex_click",
                                    action: JSON.stringify({
                                        id: props?.item?.id,
                                        name: props?.item?.name,
                                    }),
                                });
                            }}
                        >
                            <Button
                                className={classNames("fs-12 px-1", { "w-100": props?.nearBy })}
                                variant={"outline-primary"}
                            >
                                Venue Details
                            </Button>
                        </Link>
                        <Link
                            className="text-center "
                            to={`${process.env.REACT_APP_BOOKING_URL}/?auth=${props?.item?.id}`}
                            onClick={() => {
                                ReactGA.event("contact_initiated", {
                                    category: "contact_initiated",
                                    action: JSON.stringify({
                                        id: props?.item?.id,
                                        name: props?.item?.name,
                                    }),
                                });
                            }}
                        >
                            <Button
                                className={classNames("text-light fs-12 px-1", {
                                    "d-none": props?.nearBy,
                                })}
                                variant={"primary"}
                            >
                                Book Now
                                <FaArrowRightLong />
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
};
